import {
    GETMODULEALLOCATIONLISTFORADMIN_SUCCESS,
    GETMODULEALLOCATIONLISTFORADMIN_FAILED,
    RESET_GETMODULEALLOCATIONLISTFORADMIN,
    LOADING_GETMODULEALLOCATIONLISTFORADMIN,
    NETWORK_ERROR_GETMODULEALLOCATIONLISTFORADMIN,
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetGetModuleAllocationList = () => {
    return { type: RESET_GETMODULEALLOCATIONLISTFORADMIN };
};

const GetModuleAllocationList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETMODULEALLOCATIONLISTFORADMIN });
    await adminServices
        .post("getModuleAllocationListforadmin", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                
                case "success":
                    dispatch(getModuleAllocationListsuccess(res.data));
                    break;
                default:
                    dispatch(getModuleAllocationListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_GETMODULEALLOCATIONLISTFORADMIN,
                payload: err
            });
        });
};


function getModuleAllocationListsuccess(data) {
    return {
        type: GETMODULEALLOCATIONLISTFORADMIN_SUCCESS,
        payload: data
    };
}
function getModuleAllocationListFailed(data) {
    return {
        type: GETMODULEALLOCATIONLISTFORADMIN_FAILED,
        payload: data
    };
}

export { GetModuleAllocationList, resetGetModuleAllocationList }